import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { ContactTemp } from './contact-temp.model';
import { ContactTempPopupService } from './contact-temp-popup.service';
import { ContactTempService } from './contact-temp.service';
import { Contact, ContactService } from '../contact';

@Component({
    selector: 'jhi-contact-temp-dialog',
    templateUrl: './contact-temp-dialog.component.html'
})
export class ContactTempDialogComponent implements OnInit {

    contactTemp: ContactTemp;
    authorities: any[];
    isSaving: boolean;

    contacts: Contact[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private contactTempService: ContactTempService,
        private contactService: ContactService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['contactTemp', 'contactType', 'contactStatus']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contactService.query().subscribe(
            (res: Response) => { this.contacts = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.contactTemp.id !== undefined) {
            this.contactTempService.update(this.contactTemp)
                .subscribe((res: ContactTemp) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.contactTempService.create(this.contactTemp)
                .subscribe((res: ContactTemp) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: ContactTemp) {
        this.eventManager.broadcast({ name: 'contactTempListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackContactById(index: number, item: Contact) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-contact-temp-popup',
    template: ''
})
export class ContactTempPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private contactTempPopupService: ContactTempPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.contactTempPopupService
                    .open(ContactTempDialogComponent, params['id']);
            } else {
                this.modalRef = this.contactTempPopupService
                    .open(ContactTempDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact-temp/contact-temp-dialog.component.ts